// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Ribbon(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Ribbon" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2C4 1.44772 4.44772 1 5 1H19C19.5523 1 20 1.44772 20 2V21.9996L12 17.4062L4 22V2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Ribbon.js.map